import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "shipping", spoke: "shipping", title: "Shipping", icon: LocalShippingOutlinedIcon, order: 48, entries: [
  { label: "Dashboard", to: "/app/shipping", permission: "shipping.shipment.view" },
  { label: "Shipping queue", to: "/app/shipping/queue", permission: "shipping.shipment.view" },
  { label: "Shipments", to: "/app/shipping/shipments", permission: "shipping.shipment.view" },
  { label: "Pick waves", to: "/app/shipping/waves", permission: "shipping.shipment.view" },
  { label: "Carriers", to: "/app/masterdata/carriers", permission: "shipping.carrier.view" },
  { label: "Allocation rules", to: "/app/masterdata/allocation-rules", permission: "inventory.stock.view" },
] });
